import Vue from "vue";
import Vuetify from 'vuetify/lib';
import 'vuetify/src/stylus/app.styl';
import FeatureFlagPlugin from '@nuskin/ns-feature-flags-vue';

import NsPaymentManager from "./payment-section/NsPaymentManager.vue";
import NsPaymentSelector from "./payment-section/NsPaymentSelector.vue";
import NsAddressSelector from "./address-section/NsAddressSelector.vue";
import NsShippingAddressForm from "./address-section/NsShippingAddressForm.vue";
import NsAddressManager from "./address-section/NsAddressManager.vue";
import paymentBynderImagesMap from "./payment-section/paymentBynderImagesMap";

window.vue = Vue;
Vue.config.silent = true;

Vue.use(FeatureFlagPlugin);
Vue.use(Vuetify, {
    iconfont: 'md',
});

// load in the configMaps used by app-elements
import { events } from '@nuskin/ns-util';
import { getConfiguration } from '@nuskin/configuration-sdk';
const dcRunConfigCallback = (runConfig) => {
  if (runConfig && typeof runConfig.clientId === 'string') {
    events.unsubscribe(events.global.RUN_CONFIG_CHANGED, dcRunConfigCallback);
    getConfiguration(['Account', 'Checkout', 'Basic']).then(() =>
      console.log('design-componants config loaded')
    );
  }
};

events.getValue(events.global.RUN_CONFIG_CHANGED, dcRunConfigCallback, true);

export {
    NsPaymentManager,
    NsPaymentSelector,
    NsAddressSelector,
    NsShippingAddressForm,
    NsAddressManager,
    paymentBynderImagesMap
}
